<template lang="pug" functional>
    .quote

        p.corners.corners--white
            span(v-html='props.text')


</template>

<script>
export default {
    name: 'Quote',

    props: {
        text: {
            type: String,
            default: ''
        }
    }
};
</script>

<style lang="scss">
@import '@/assets/css/vars.scss';
.quote {
    font-weight: bold;
    text-align: center;
    width: 100%;

    p {
        display: inline-block;
        width: auto;
        padding: 20px 50px;
        max-width: 60vw;

        @media (--viewport-mobile) {
            max-width: 100%;
            padding: 5vw;
        }
    }
}
</style>
